import dynamic from 'next/dynamic';
import React, { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import { delayWrapper } from 'src/utils/delayWrapper';

import { prodAPI, prodswagger } from 'src/utils/links';

const NavigationLink = dynamic(
  () =>
    delayWrapper<typeof NavigationLink>(
      import('src/shared-components/NavigationLink/NavigationLink')
    ),
  {
    loading: () => <Skeleton width={'100%'} height={32} />
  }
);

const AboutApi: FC = () => {
  return (
    <div>
      <p className="mb-1">
        <span className="fs-body-bold">Prod API: </span>
        <NavigationLink passClassName="underline " href={prodAPI}>
          {prodAPI}
        </NavigationLink>
      </p>
      <p className="mb-1">
        <span className="fs-body-bold">Prod Swagger: </span>
        <NavigationLink passClassName="underline " href={prodswagger}>
          {prodswagger}
        </NavigationLink>
      </p>
      <p className="mb-1">
        Для аутентифікації клієнт разом із запитом надсилає серверу логін та
        пароль. Ці дані надсилаються в заголовку запиту Authorization у вигляді
        base64 коду.
      </p>
      <p className="mb-1">Authorization: Basic base64_encode(login:password)</p>
    </div>
  );
};

export default AboutApi;
